
<template>
  <div>
    <h5 class="measurement-title mb-0"> {{$t('dashboard_new_evollu.parameters.spirometry')}} </h5>
    <span class="measurement-timestamp"> {{$t('checkup_plus.reports.measurements.last_measurement_date', {date: moment(data.lastMeasurementTimestamp).format('DD/MM/YYYY HH:mm')})}} </span>

    <table class="w-100">
      <tr>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/spirometry.svg">
              <div>
                <h5 class="card-title">FEV1</h5>
              </div>
            </div>
            <span class="card-title">
              {{ fev1Data.value }} {{fev1Data.units}}
            </span>
            <br>
            <span class="card-description">
              <span style="font-weight: bold">{{ fev1Data.previousValue }} {{ fev1Data.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }}
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/spirometry.svg">
              <div>
                <h5 class="card-title">FEV6</h5>
              </div>
            </div>
            <span class="card-title">
              {{ fev6Data.value }} {{fev6Data.units}}
            </span>
            <br>
            <span class="card-description">
              <span style="font-weight: bold">{{ fev6Data.previousValue }} {{ fev6Data.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }}
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/spirometry.svg">
              <div>
                <h5 class="card-title">FEV1/FEV6</h5>
              </div>
            </div>
            <span class="card-title">
              {{ fev1fev6Data.value }} {{fev1fev6Data.units}}
            </span>
            <br>
            <span class="card-description">
              <span style="font-weight: bold">{{ fev1fev6Data.previousValue }} {{ fev1fev6Data.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }}
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/spirometry.svg">
              <div>
                <h5 class="card-title">FEF-2575</h5>
              </div>
            </div>
            <span class="card-title">
              {{ fefData.value }} {{fefData.units}}
            </span>
            <br>
            <span class="card-description">
              <span style="font-weight: bold">{{ fefData.previousValue }} {{ fefData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }}
            </span>
          </div>
        </td>
      </tr>
      <tr v-for="elem in data.results">
        <td colspan="4">
          <div class="measurement-card h-100 d-flex justify--space-between">
            <div class="title-container d-flex align-items-center">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/warning_yellow.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.result') }}</h5>
              </div>
            </div>
            <span :style="{ color: elem.resultColour }">
              {{ elem.resultName }}
            </span>
          </div>

          <div class="measurement-card h-100 mt-2">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/reference_values.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.measurement_reference_values', {measurement: $t('dashboard_new_evollu.parameters.spirometry')}) }}</h5>
              </div>
            </div>
            <div>
              <table>
                <tr v-for="elem in elem.referenceValues">
                  <td>
                    {{handleReferenceValuesCriterias(elem)}}
                  </td>
                  <td>
                    {{elem.resultMatchingCriteria}}
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <div class="measurement-card h-100 mt-2">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/info_circle.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.patient_overall_summary.recommendation') }}</h5>
              </div>
            </div>
            <span class="card-text-normal">
              {{ elem.recommendations }}
            </span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      fev1Data: null,
      fev6Data: null,
      fev1fev6Data: null,
      fefData: null,
    }
  },
  created() {
    this.data.measurementValues.forEach(elem => {
      if(elem.attributeCode === 'FEV1') {
        this.fev1Data = elem
      } else if(elem.attributeCode === 'FEV6') {
        this.fev6Data = elem
      }else if(elem.attributeCode === 'FEV1FEV6') {
        this.fev1fev6Data = elem
      } else if(elem.attributeCode === 'FEF2575') {
        this.fefData = elem
      }
    })
  },
  methods: {
    handleReferenceValuesCriterias(elem) {
      var str = ""
      let index = 0
      let criteriasLength = elem.criteriaList.length
      if(elem.operator === "AND") {
        elem.criteriaList.forEach(elem => {
          str+= `${elem.attributeName} ${elem.criteria} `
          ++index
          if (index < criteriasLength) {
            str += "& "
          }

        })
      }
      return str
    }
  }
}
</script>

<style scoped lang="scss">
.measurement-card {
  padding: 20px;
  width: 100%;
  border: 1px solid lightgrey;
  border-radius: 15px;
  margin-bottom: 0;
}


table {
  width: 100%;
  height: 100%;
  table-layout: fixed;
}

td {
  height: 100%;
}

table td {
  padding-bottom: 10px;
}

table tr {
  margin-bottom: 10px;
}

table td:not(:first-child) {
  padding-left: 12px;
}

</style>
